import { config } from './chunk-Z7B3ZQHS.js';

// ../../node_modules/@jwplayer/fe-common/module/cookies/index.js
function isDefined(v) {
  return !(typeof v === "undefined");
}
function formatCookie(key, value, config2) {
  if (key.trim() === "") {
    throw new Error("Key may not be empty");
  }
  return [
    `${key}=${value}`,
    ...Object.entries(config2 ?? {}).map(([configKey, configValue]) => {
      if (typeof configValue === "undefined" || configValue === null) {
        return;
      }
      if (configValue === true) {
        return configKey;
      }
      if (configValue instanceof Date) {
        configValue = configValue.toUTCString();
      }
      return `${configKey}=${configValue}`;
    })
  ].filter(isDefined).join("; ");
}
function setCookie(key, value, config2) {
  document.cookie = formatCookie(key, value, config2);
}
function deleteCookie(key, config2) {
  document.cookie = formatCookie(key, "", {
    ...config2,
    "Max-Age": 0
  });
}
function getCookie(key) {
  const cookies = document.cookie.split(";").map((i) => i.trim());
  for (const cookie of cookies) {
    const parts = cookie.split("=");
    if (parts.length < 2) {
      continue;
    }
    const name = parts.shift();
    if (name === key) {
      return parts.join("=");
    }
  }
  return void 0;
}

// ../base/auth/events.ts
var AuthEvents = class {
  #handlers = {
    refreshed: [],
    expired: []
  };
  /**
   * Subscribe to event
   *
   * Returns function to unsubscribe
   *
   * @param event Event name
   * @param handler Event handler
   */
  subscribe(event, handler) {
    if (this.#handlers[event].includes(handler)) {
      return;
    }
    this.#handlers[event].push(handler);
    return () => {
      this.#handlers[event] = this.#handlers[event].filter((h) => h !== handler);
    };
  }
  /**
   * Emit event (with arguments)
   */
  emit(event, ...args) {
    this.#handlers[event].forEach((h) => h.apply(h, args));
  }
};

// ../base/auth/cache.ts
var AuthCache = class {
  #refreshTimeout;
  #expireTimeout;
  // not implemented yet
  /**
   * Cached 'session' object
   */
  #cache;
  /**
   * Cached token
   */
  #cachedToken;
  #events;
  #opts;
  constructor(events2, opts) {
    this.#events = events2;
    this.#opts = { ...opts };
  }
  resetTimers() {
    clearTimeout(this.#refreshTimeout);
    clearTimeout(this.#expireTimeout);
  }
  getToken() {
    if (!this.#cachedToken) {
      this.#cachedToken = getCookie(this.#opts.authCookieName) || void 0;
    }
    return this.#cachedToken;
  }
  /**
   * Needs to be implemented in child class.
   *
   * This method will get called when refreshing the auth token. It needs to return the session object and token.
   */
  async refreshAuth() {
    throw new Error("Not implemented");
  }
  get() {
    if (!this.#cache) {
      return;
    }
    return { ...this.#cache };
  }
  /**
   * Update/set cached session object and auth token
   *
   * Recursive function that automatically refreshes the session after a timeout.
   */
  set(cache2, token) {
    this.setCacheAndToken(cache2, token);
    setCookie(this.#opts.authCookieName, token);
    this.#events.emit("refreshed", cache2);
    this.#refreshTimeout = setTimeout(async () => {
      const { obj, token: token2 } = await this.refreshAuth();
      this.set(obj, token2);
    }, this.#opts.authRefreshTime);
  }
  /**
   * Only set cache and auth token, but don't start handling the session
   */
  setCacheAndToken(cache2, token) {
    this.#cache = cache2;
    this.#cachedToken = token;
  }
  /**
   * Clear the cached session and delete the auth token (cookie).
   */
  clear() {
    this.resetTimers();
    this.#cachedToken = void 0;
    deleteCookie(this.#opts.authCookieName);
    this.#cache = void 0;
  }
};

// src/auth/events.ts
var AuthGatewayEvents = class extends AuthEvents {
};
var events = new AuthGatewayEvents();

// src/auth/util.ts
function extractAuthToken(obj) {
  return obj.authentication.dashboard;
}

// src/auth/cache.ts
var AuthGatewayCache = class extends AuthCache {
  constructor() {
    super(events, {
      authCookieName: config.get().auth.cookies.token,
      authRefreshTime: config.get().auth.autoRefreshTime
    });
  }
  async refreshAuth() {
    const { jwApi } = await import('./api-K6GPXJS4.js');
    const obj = (await jwApi("dashboard-scope", "read", {})).data;
    return {
      obj,
      token: extractAuthToken(obj)
    };
  }
};
var cache = new AuthGatewayCache();

export { cache, deleteCookie, events, extractAuthToken, getCookie, setCookie };
